import styled from 'styled-components';

export default styled.input`
  border: ${props => props.theme.inputBorders};
  border-radius: ${props => (props.theme.textareaBorderRadius ? props.theme.textareaBorderRadius : '0')};
  height: 42px;
  line-height: 42px;
  padding: 0 0.6em;
  font-size: ${props => props.theme.fontSizePrimary};
  ${props => (props.isInvalid ? `border-color: ${props.theme.invalidColor} !important` : '')};
`;
